import {handleMethodChange} from "../../../../helpers/pricing/calculatorHelper.ts";
import {PaymentMethod} from "../../../../@types/pricingCalculatorFieldsResources.tsx";
import {Trans, useTranslation} from "react-i18next";

const SelectOptionsMethodSelect = (
    {sectionClass, sectionHeadingClass, selectedMethod, setSelectedMethod, methods}:
        {
            sectionClass: string,
            sectionHeadingClass: string|undefined,
            selectedMethod: string,
            setSelectedMethod: (arg0: string) => void,
            methods: PaymentMethod[],
        }
) => {

    const {t} = useTranslation();

    return (
        <>
            <div className={sectionClass}>
                <label htmlFor="payment_method" className={sectionHeadingClass}>{t('payment_method')}</label>
                <select
                    className="calculator_payment_method m-calculator_payment_method"
                    id="payment_method"
                    name="payment_method"
                    value={selectedMethod}
                    onChange={(e) => handleMethodChange(e, setSelectedMethod)}
                >
                    {methods.map((method, index) => (
                        <option key={index} value={method.name}>
                            <Trans t={t}>
                                {t(method.name)}
                            </Trans>
                        </option>
                    ))}
                </select>
            </div>
        </>
    )
}

export default SelectOptionsMethodSelect;
